import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import useAppStore from '@views/app.store';
import ComboGenerator from './comboGenerator';
export const rules = [{
  label: '前缀+产品/训练词',
  value: '7',
  rule: ['prefix', 'main']
}, {
  label: '产品/训练词+应用后缀',
  value: '6',
  rule: ['main', 'suffix2']
}, {
  label: '前缀+产品/训练词+应用后缀',
  value: '3',
  rule: ['prefix', 'main', 'suffix2']
}, {
  label: '产品/训练词+品牌/服务后缀',
  value: '5',
  rule: ['main', 'suffix']
}, {
  label: '前缀+产品/训练词+品牌/服务后缀',
  value: '2',
  rule: ['prefix', 'main', 'suffix']
}, {
  label: '产品/训练词+品牌/服务后缀+应用后缀',
  value: '4',
  rule: ['main', 'suffix', 'suffix2']
}, {
  label: '前缀+产品/训练词+品牌/服务后缀+应用后缀',
  value: '1',
  rule: ['prefix', 'main', 'suffix', 'suffix2']
}];
const getWords = card => {
  card.words = [];
  card.content.split('\n').forEach(item => {
    const word = item.trim();
    if (word && card.words.indexOf(word) === -1) {
      card.words.push(word);
    }
  });
};
export const cards = ref([{
  id: 'prefix',
  name: '前缀',
  placeholder: '输入词，多个词之换行一行一个',
  content: '',
  // Array.from({length: 10}, (_, i) => 'a' + (i + 1)).join('\n'),
  textColor: '#1D2129',
  buttonText: '使用预设前缀',
  // default: [
  //   '口碑好的',
  //   '耐用的',
  //   '比较好的',
  //   '靠谱的',
  //   '有实力的',
  //   '可靠的',
  //   '诚信的',
  //   '正规的',
  //   '专业的',
  //   '质量好的',
  //   '热门的',
  //   '知名的',
  //   '评价高的',
  //   '优质的',
  //   '优秀的'
  // ],
  default: ['耐用的', '专业的', '质量好的', '热门的', '知名的', '评价高的', '优秀的', '最佳', '顶级', '领先', '值得信赖', '已验证', '经验丰富', '已认证'],
  outerDefault: ['durable', 'professional', 'high-quality', 'popular', 'well-known', 'highly-rated', 'excellent', 'Best', 'Top', 'Leading', 'Trusted', 'Verified', 'Experienced', 'Certified', 'Alternatives to', 'How to choose', 'Key factors to consider', 'Where to buy'],
  onClick(card) {
    if (useAppStore().geoMode === 'outer') {
      card.content = card.outerDefault.join('\n');
      return;
    }
    card.content = card.default.join('\n');
  },
  getWords
}, {
  id: 'main',
  name: '产品/训练词',
  placeholder: '输入词，多个词之换行一行一个',
  content: '',
  // Array.from({length: 10}, (_, i) => 'b' + (i + 1)).join('\n'),
  textColor: '#1D2129',
  required: true,
  getWords
}, {
  id: 'suffix',
  name: '品牌/服务后缀',
  placeholder: '输入词，多个词之换行一行一个',
  content: '',
  // Array.from({length: 10}, (_, i) => 'c' + (i + 1)).join('\n'),
  textColor: '#1D2129',
  buttonText: '使用预设后缀',
  default: ['品牌', '公司', '厂家', '工厂', '企业', '生产厂家', '供应商', '销售厂家', '生产商', '加工厂', '源头厂家', '直销厂家', '定制厂家', '批发厂家', '制造厂家', '实力厂家'],
  outerDefault: ['brand', 'company', 'manufacturer', 'factory', 'producer', 'supplier', 'custom manufacturer', 'OEM manufacturer', 'ODM manufacturer', 'direct manufacturer', 'production company', 'in China', 'from China', 'bulk supplier'],
  onClick(card) {
    if (useAppStore().geoMode === 'outer') {
      card.content = card.outerDefault.join('\n');
      return;
    }
    card.content = card.default.join('\n');
  },
  getWords
}, {
  id: 'suffix2',
  name: '应用后缀',
  placeholder: '输入词，多个词之换行一行一个',
  content: '',
  // Array.from({length: 10}, (_, i) => 'c' + (i + 1)).join('\n'),
  textColor: '#1D2129',
  buttonText: '使用预设后缀',
  default: ['推荐', '排行', '排名', '电话', '联系电话', '联系方式', '怎么联系', '哪家好', '哪家强', '怎么选', '有哪些', '哪家权威', '哪里有卖', '哪家靠谱', '哪家专业', '哪家质量好', '哪家便宜', '哪家可靠', '推荐几家', '帮我推荐几家', '如何选', '选哪家', '哪里有'],
  outerDefault: ['Recommended manufacturers', 'Top manufacturers', 'Top / Best', 'Best manufacturers', 'Top suppliers', 'Leading manufacturers', 'Trusted suppliers', 'Manufacturer comparison', 'Supplier list', 'Buying guide', 'Supplier selection guide', 'Customization options', 'OEM / ODM services'],
  onClick(card) {
    if (useAppStore().geoMode === 'outer') {
      card.content = card.outerDefault.join('\n');
      return;
    }
    card.content = card.default.join('\n');
  },
  getWords
}]);
export const getRuleRequired = rule => {
  let need = [];
  rule.forEach(r => {
    need = need.concat(r.rule);
  });
  const ret = [...new Set(need)];
  return ret;
};
export const checkRequired = (rule, allCard) => {
  const empty = [];
  rule.forEach(r => {
    const card = allCard.find(c => c.id === r);
    if (!card.words.length) {
      empty.push(card.name);
    }
  });
  return empty;
};
export const calcCombine = (rule, allCard) => {
  const generator = new ComboGenerator(rule, 2000);
  const userInput = {};
  allCard.forEach(c => {
    userInput[c.id] = c.words || [];
  });
  const finalResults = generator.generate(userInput);
  return finalResults;
};